import { compose } from "redux";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const {
  CERTIFICATION_CONFIGURATIONS,
  LOADER_IDENTIFIER,
  LIST_IDENTIFIER,
  SELECTED_CERTIFICATION,
  ENRICHMENT_SELECTED_CERTIFICATION,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CERTIFICATION_CONFIGURATIONS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [CERTIFICATION_CONFIGURATIONS, LIST_IDENTIFIER],
        action.payload
      ),
      immutableSet([CERTIFICATION_CONFIGURATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.CERTIFICATION_CONFIGURATIONS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([CERTIFICATION_CONFIGURATIONS, LOADER_IDENTIFIER], false),
      immutableSet([CERTIFICATION_CONFIGURATIONS, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.CONFIGURATION_ENRICHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [ENRICHMENT_SELECTED_CERTIFICATION, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.CONFIGURATION_ENRICHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [ENRICHMENT_SELECTED_CERTIFICATION, LIST_IDENTIFIER],
        action.payload
      ),
      immutableSet(
        [ENRICHMENT_SELECTED_CERTIFICATION, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.CONFIGURATION_ENRICHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet(
        [ENRICHMENT_SELECTED_CERTIFICATION, LOADER_IDENTIFIER],
        false
      ),
      immutableSet([ENRICHMENT_SELECTED_CERTIFICATION, LIST_IDENTIFIER], [])
    )(state),

  [actionTypes.SET_SELECTED_CERTIFICATION_CONFIGURATION]: (
    state: any,
    action: any
  ) => immutableSet([SELECTED_CERTIFICATION], action.payload, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }

  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
